module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "pt-sans",
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "ma-0": "",
      "pa-0": "",
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "height": "100%",
      "background-color": "#ea1d24"
    },
    attrs: {
      "md6": "",
      "hidden-sm-and-down": ""
    }
  }, [_c('div', [_c('img', {
    staticClass: "lazyload img-responsive",
    attrs: {
      "data-src": "/static/img/img-login.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "destaque-login"
  }, [_c('img', {
    staticClass: "lazyload",
    attrs: {
      "data-src": "/static/img/icone-cadastro.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('h4', [_vm._v("Conquiste!")]), _vm._v(" "), _c('h6', [_vm._v("Venda mais para Condomínios! Conheça a ferramenta que coloca sua empresa em contato com quem compra!")])])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-layout', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": "",
      "offset-xs1": "",
      "sm6": "",
      "offset-sm3": "",
      "grid-list-xs": "",
      "pt-5": ""
    }
  }, [_c('div', {
    staticClass: "titulo-logo mb-4 float-l"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/logo.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('h4', [_vm._v("CondoPlaza")])]), _vm._v(" "), _c('v-form', {
    ref: "form",
    staticClass: "mt-5"
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "s12": "",
      "offset-s1": "",
      "grid-list-xs": "",
      "pt-5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Usuário",
      "rules": _vm.usuarioRegras,
      "prepend-icon": "person",
      "validate-on-blur": "",
      "required": ""
    },
    model: {
      value: (_vm.login),
      callback: function($$v) {
        _vm.login = $$v
      },
      expression: "login"
    }
  })], 1), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "senha",
      "label": "Senha",
      "type": "password",
      "validate-on-blur": "",
      "rules": _vm.senhaRegras,
      "prepend-icon": "lock_open",
      "required": ""
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        return _vm.autenticar($event)
      }
    },
    model: {
      value: (_vm.senha),
      callback: function($$v) {
        _vm.senha = $$v
      },
      expression: "senha"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Mantenha-me conectado",
      "color": "teal darken-1"
    },
    model: {
      value: (_vm.manterLogin),
      callback: function($$v) {
        _vm.manterLogin = $$v
      },
      expression: "manterLogin"
    }
  }, [_vm._v("\n              entre aequi\n              "), _c('div', {
    staticClass: "link"
  }, [_c('router-link', {
    attrs: {
      "to": "/hello"
    }
  }, [_vm._v("Não consigo acessar minha conta!")])], 1)]), _vm._v(" "), _c('div', {}, [_c('v-btn', {
    staticClass: "btn-green",
    attrs: {
      "round": "",
      "loading": _vm.loading,
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.autenticar
    },
    nativeOn: {
      "click": function($event) {
        _vm.loader = 'loading'
      }
    }
  }, [_vm._v("\n                Entrar\n                "), _c('span', {
    staticClass: "custom-loader",
    attrs: {
      "slot": "loader"
    },
    slot: "loader"
  }, [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("cached")])], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "font-16px"
  }, [_c('LembreteSenha')], 1), _vm._v(" "), _c('div', {
    staticClass: "font-16px cadastro-footer"
  }, [_vm._v("\n             Não tem uma conta"), _c('span', [_vm._v(" CondoPlaza")]), _vm._v("? "), _c('router-link', {
    staticClass: "link",
    attrs: {
      "to": "/Cadastro"
    }
  }, [_vm._v("Cadastre-se")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-89582690","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/index.vue
// module id = 444
// module chunks = 7 11 16